import {RxJsonSchema} from 'rxdb';

export const UserGoalsSchema: RxJsonSchema | any = {
    "version": 0,
    "type": "object",
    "title": "User Goals",
    "properties": {
        "category": {
            "type": "string"
        },
        "shortText": {
            "type": "string"
        },
        "text": {
            "type": "string"
        }
    },
    "required": [
        "category",
        "shortText",
        "text"
    ],
};
